module.exports = __webpack_public_path__ + "static/media/ENCONTRO_7_ED_FISICA.5a583cce.pdf";